// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2z8oj","fileBtn":"File_fileBtn__3TNos","closeBtn":"File_closeBtn__1tdTW","fileSelected":"File_fileSelected__4k6XV","disabled":"File_disabled__3vNgu"};